module.exports = __webpack_public_path__ + "static/media/Drain_Fly.c94a2fda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Drain_Fly.jpg
// module id = 132
// module chunks = 0